// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ViewFailedPayout-space1-_LCpD {
	margin-bottom: 6px !important;
}

.ViewFailedPayout-space2-XySWk {
	margin-bottom: 12px !important;
}

.ViewFailedPayout-space3-lLF2r {
	margin-bottom: 18px !important;
}

.ViewFailedPayout-space4-HNuQ5 {
	margin-bottom: 24px !important;
}

.ViewFailedPayout-space5-V9pHY {
	margin-bottom: 30px !important;
}

.ViewFailedPayout-space6-BFyty {
	margin-bottom: 36px !important;
}

.ViewFailedPayout-space7-iyj2s {
	margin-bottom: 42px !important;
}

.ViewFailedPayout-space8-KtNjB {
	margin-bottom: 48px !important;
}

.ViewFailedPayout-spaceTop1-IQK8f {
	margin-top: 6px !important;
}

.ViewFailedPayout-spaceTop2-aAv1f {
	margin-top: 12px !important;
}

.ViewFailedPayout-spaceTop3-Aa_IM {
	margin-top: 18px !important;
}

.ViewFailedPayout-spaceTop4-g1gMe {
	margin-top: 24px !important;
}

.ViewFailedPayout-spaceTop5-DCEoF {
	margin-top: 30px !important;
}

.ViewFailedPayout-spaceTop6-NiEgX {
	margin-top: 36px !important;
}

.ViewFailedPayout-spaceTop7-so2Pj {
	margin-top: 42px !important;
}

.ViewFailedPayout-spaceTop8-SopNd {
	margin-top: 48px !important;
}

.ViewFailedPayout-noMargin-ezc9F {
	margin: 0px !important;
}

.ViewFailedPayout-padding1-H38s1 {
	padding-bottom: 6px !important;
}

.ViewFailedPayout-padding2-VmUCP {
	padding-bottom: 12px !important;
}

.ViewFailedPayout-padding3-mVf46 {
	padding-bottom: 18px !important;
}

.ViewFailedPayout-padding4-MYsLa {
	padding-bottom: 24px !important;
}

.ViewFailedPayout-padding5-B0kzX {
	padding-bottom: 30px !important;
}

.ViewFailedPayout-padding6-ftOY7 {
	padding-bottom: 36px !important;
}

.ViewFailedPayout-padding7-zmY1E {
	padding-bottom: 42px !important;
}

.ViewFailedPayout-paddingTop1-SReaT {
	padding-top: 6px !important;
}

.ViewFailedPayout-paddingTop2-CwARN {
	padding-top: 12px !important;
}

.ViewFailedPayout-paddingTop3-N82Xg {
	padding-top: 18px !important;
}

.ViewFailedPayout-paddingTop4-Ur7XL {
	padding-top: 24px !important;
}

.ViewFailedPayout-paddingTop5-x6iwT {
	padding-top: 30px !important;
}

.ViewFailedPayout-paddingTop6-Cjql4 {
	padding-top: 36px !important;
}

.ViewFailedPayout-paddingTop7-ssjJ8 {
	padding-top: 42px !important;
}

.ViewFailedPayout-noPadding-MNWYG {
	padding: 0px !important;
}

.ViewFailedPayout-spaceMarginBottom0-a1hRx {
	margin-bottom: 0;
}

.ViewFailedPayout-textBold-FIjro {
	font-weight: 500 !important;
}

.ViewFailedPayout-textBolder-v3sN4 {
	font-weight: 700 !important;
}

.ViewFailedPayout-textNormal-v22ql {
	font-weight: normal !important;
}

/*New Design Text Colors */

.ViewFailedPayout-textDarkBlue-nt0cy {
	color: rgb(20, 39, 94) !important;
}

.ViewFailedPayout-textLightBlue-vxkXV {
	color: rgb(57, 87, 106) !important;
}

.ViewFailedPayout-textLightSandleGreen-Ck1RB {
	color: rgb(76, 86, 41) !important;
}

.ViewFailedPayout-textLightBrown-APK3s {
	color: rgb(115, 79, 33) !important;
}

.ViewFailedPayout-textMediumMaroon-TnkcA {
	color: rgb(87, 37, 51) !important;
}

.ViewFailedPayout-textBrown-HVU0z {
	color: rgb(160, 47, 24) !important;
}

.ViewFailedPayout-textMaroon-dAHvl {
	color: rgb(155, 49, 67) !important;
}

.ViewFailedPayout-textDarkBrown-y7WI6 {
	color: rgb(83, 18, 16) !important;
}

.ViewFailedPayout-textMediumBrown-owHin {
	color: rgb(142, 28, 10) !important;
}

.ViewFailedPayout-textSkyBlue-fHpKM {
	color: rgb(37, 117, 141) !important;
}

.ViewFailedPayout-textGray-xBR3G {
	color: rgb(77, 65, 51) !important;
}

.ViewFailedPayout-errorMessage-lLW28 {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}

/** Admin - Common - Start **/

.ViewFailedPayout-userText-oIimf {
	padding-top: 3px;
	color: var(--common-text-color);
	margin: 0px;
	font-size: 14px;
}

.ViewFailedPayout-panelHeader-Jrn5Q {
	border-radius: 4px;
	padding: 20px 25px;
	border: 1px solid var(--primary-border);
}

.ViewFailedPayout-exportSection-r57Bx {
	background: var(--common-gray-bg-color);
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
}

.ViewFailedPayout-exportSectionGridSub-ge3qD {
	grid-template-columns: 50% 49% !important;
}

.ViewFailedPayout-exportText-_4nzV {
	color: var(--common-text-color) !important;
	text-decoration: none !important;
	display: inline-block;
	float: right;
}

.ViewFailedPayout-exportLinkImg-fMRAi {
	background: var(--primary-white-bg);
	padding: 10px;
	margin-left: 12px;
	border-radius: 4px;
}

.ViewFailedPayout-exportImg-Zhhmu {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.ViewFailedPayout-linkBtn-r4sHw {
	line-height: 24px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 15px;
	text-align: center;
}

.ViewFailedPayout-table-Lu5BP {
	display: table;
}

.ViewFailedPayout-tableRow-fQrbt {
	display: table-row;
}

.ViewFailedPayout-tableCell-MDH7r {
	display: table-cell;
	float: none;
}

.ViewFailedPayout-formGroup-J0lIQ {
	margin-bottom: 6px;
}

.ViewFailedPayout-marginTop0-ZRFpP {
	margin-top: 0;
}

.ViewFailedPayout-marginBottom20-ASlG0 {
	margin-bottom: 20px;
}

/******************* Admin Banner Image Section Start ****************/

.ViewFailedPayout-bannerImageBg-qfFxO {
	width: 100%;
	height: 100%;
	min-height: 179px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	position: relative;
	border-radius: 0px;
}

.ViewFailedPayout-bannerDelete-uSg4s {
	position: absolute;
	top: 5px;
	right: 20px;
}

/*******************Admin Modal Start **********************/

a,
a:hover {
	cursor: pointer;
}

.ViewFailedPayout-exportLink-M5Bio {
	padding-top: 10px;
	padding-right: 10px;
}

.ViewFailedPayout-seachContent-uYL3m {
	padding-left: 0px;
	margin-bottom: 5px;
}

.ViewFailedPayout-marginBottom9-K5Dek {
	margin-bottom: 9px;
}

.ViewFailedPayout-spaceTop52-yUQjn {
	margin-top: 52px;
}

.ViewFailedPayout-profileViewInner-HUOU5 {
	padding: 10px;
	border-top: 1px solid var(--primary-border);
	word-break: break-all;
}

.ViewFailedPayout-profileViewMain-zpogq {
	border: 1px solid var(--primary-border);
	border-radius: 0px;
	border-top: 0;
}

.ViewFailedPayout-profileViewlabel-bEahm {
	display: inline-block;
	width: 38%;
	vertical-align: middle;
}

.ViewFailedPayout-profileViewMainContent-bM4sh {
	display: inline-block;
	width: 62%;
	vertical-align: middle;
}

.ViewFailedPayout-reviewsFormStar-RPEny {
	font-size: 32px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 2px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

.ViewFailedPayout-reviewsFormStar-RPEny svg {
	cursor: pointer;
}

.ViewFailedPayout-addLanguageText-HN2mA {
	font-size: 16px;
}

/***************** Export Section Start *********************/

@media screen and (max-width: 991px) {
	.ViewFailedPayout-exportSection-r57Bx {
		grid-template-columns: 100%;
	}

	.ViewFailedPayout-spaceTop52-yUQjn {
		margin-top: 18px;
	}

	.ViewFailedPayout-exportText-_4nzV {
		float: none;
		margin-top: 12px;
	}

	.ViewFailedPayout-exportSectionGridSub-ge3qD {
		grid-template-columns: 100% !important;
	}
}

/***************** Export Section End *********************/

/*******************Admin Modal Start **********************/

/*******************Admin Modal End **********************/

/*********************** Profile View Section  Start***********************/

@media screen and (max-width: 767px) {
	.ViewFailedPayout-profileViewlabel-bEahm {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.ViewFailedPayout-profileViewMainContent-bM4sh {
		width: 100%;
		text-align: center;
	}

	.ViewFailedPayout-panelHeader-Jrn5Q {
		padding: 15px 15px;
	}

}

/*********************** Profile View Section  Start***********************/`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-common.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5LA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;ACLA,6BAA6B;;AAC7B;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,uCAAuC;AACxC;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,uCAAuC;CACvC,gBAAgB;CAChB,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,0CAA0C;CAC1C,gCAAgC;CAChC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,mCAAmC;CACnC,aAAa;CACb,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAGA,sEAAsE;;AACtE;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,wBAAwB;CACxB,4BAA4B;CAC5B,4BAA4B;CAC5B,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA,4DAA4D;;AAC5D;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,2CAA2C;CAC3C,qBAAqB;AACtB;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,mBAAe;KAAf,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA,6DAA6D;;AAC7D;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,sCAAsC;CACvC;AACD;;AAEA,2DAA2D;;AAC3D,4DAA4D;;AAE5D,0DAA0D;;AAE1D,2EAA2E;;AAG3E;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;AAED;;AAEA,2EAA2E","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}","@import '../helpers.css';\n@import '../utils.css';\n\n/** Admin - Common - Start **/\n.userText {\n\tpadding-top: 3px;\n\tcolor: var(--common-text-color);\n\tmargin: 0px;\n\tfont-size: 14px;\n}\n\n.panelHeader {\n\tborder-radius: 4px;\n\tpadding: 20px 25px;\n\tborder: 1px solid var(--primary-border);\n}\n\n.exportSection {\n\tbackground: var(--common-gray-bg-color);\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n\tborder-top-left-radius: 20px;\n\tborder-top-right-radius: 20px;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--common-text-color) !important;\n\ttext-decoration: none !important;\n\tdisplay: inline-block;\n\tfloat: right;\n}\n\n.exportLinkImg {\n\tbackground: var(--primary-white-bg);\n\tpadding: 10px;\n\tmargin-left: 12px;\n\tborder-radius: 4px;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.linkBtn {\n\tline-height: 24px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tmargin-right: 15px;\n\ttext-align: center;\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.marginTop0 {\n\tmargin-top: 0;\n}\n\n.marginBottom20 {\n\tmargin-bottom: 20px;\n}\n\n\n/******************* Admin Banner Image Section Start ****************/\n.bannerImageBg {\n\twidth: 100%;\n\theight: 100%;\n\tmin-height: 179px;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tposition: relative;\n\tborder-radius: 0px;\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: 5px;\n\tright: 20px;\n}\n\n/*******************Admin Modal Start **********************/\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.seachContent {\n\tpadding-left: 0px;\n\tmargin-bottom: 5px;\n}\n\n.marginBottom9 {\n\tmargin-bottom: 9px;\n}\n\n.spaceTop52 {\n\tmargin-top: 52px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-top: 1px solid var(--primary-border);\n\tword-break: break-all;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 0px;\n\tborder-top: 0;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%;\n\tvertical-align: middle;\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n\tvertical-align: middle;\n}\n\n.reviewsFormStar {\n\tfont-size: 32px;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 2px;\n\tflex-wrap: wrap;\n}\n\n.reviewsFormStar svg {\n\tcursor: pointer;\n}\n\n.addLanguageText {\n\tfont-size: 16px;\n}\n\n/***************** Export Section Start *********************/\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.spaceTop52 {\n\t\tmargin-top: 18px;\n\t}\n\n\t.exportText {\n\t\tfloat: none;\n\t\tmargin-top: 12px;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n}\n\n/***************** Export Section End *********************/\n/*******************Admin Modal Start **********************/\n\n/*******************Admin Modal End **********************/\n\n/*********************** Profile View Section  Start***********************/\n\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 15px 15px;\n\t}\n\n}\n\n/*********************** Profile View Section  Start***********************/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `ViewFailedPayout-space1-_LCpD`,
	"space2": `ViewFailedPayout-space2-XySWk`,
	"space3": `ViewFailedPayout-space3-lLF2r`,
	"space4": `ViewFailedPayout-space4-HNuQ5`,
	"space5": `ViewFailedPayout-space5-V9pHY`,
	"space6": `ViewFailedPayout-space6-BFyty`,
	"space7": `ViewFailedPayout-space7-iyj2s`,
	"space8": `ViewFailedPayout-space8-KtNjB`,
	"spaceTop1": `ViewFailedPayout-spaceTop1-IQK8f`,
	"spaceTop2": `ViewFailedPayout-spaceTop2-aAv1f`,
	"spaceTop3": `ViewFailedPayout-spaceTop3-Aa_IM`,
	"spaceTop4": `ViewFailedPayout-spaceTop4-g1gMe`,
	"spaceTop5": `ViewFailedPayout-spaceTop5-DCEoF`,
	"spaceTop6": `ViewFailedPayout-spaceTop6-NiEgX`,
	"spaceTop7": `ViewFailedPayout-spaceTop7-so2Pj`,
	"spaceTop8": `ViewFailedPayout-spaceTop8-SopNd`,
	"noMargin": `ViewFailedPayout-noMargin-ezc9F`,
	"padding1": `ViewFailedPayout-padding1-H38s1`,
	"padding2": `ViewFailedPayout-padding2-VmUCP`,
	"padding3": `ViewFailedPayout-padding3-mVf46`,
	"padding4": `ViewFailedPayout-padding4-MYsLa`,
	"padding5": `ViewFailedPayout-padding5-B0kzX`,
	"padding6": `ViewFailedPayout-padding6-ftOY7`,
	"padding7": `ViewFailedPayout-padding7-zmY1E`,
	"paddingTop1": `ViewFailedPayout-paddingTop1-SReaT`,
	"paddingTop2": `ViewFailedPayout-paddingTop2-CwARN`,
	"paddingTop3": `ViewFailedPayout-paddingTop3-N82Xg`,
	"paddingTop4": `ViewFailedPayout-paddingTop4-Ur7XL`,
	"paddingTop5": `ViewFailedPayout-paddingTop5-x6iwT`,
	"paddingTop6": `ViewFailedPayout-paddingTop6-Cjql4`,
	"paddingTop7": `ViewFailedPayout-paddingTop7-ssjJ8`,
	"noPadding": `ViewFailedPayout-noPadding-MNWYG`,
	"spaceMarginBottom0": `ViewFailedPayout-spaceMarginBottom0-a1hRx`,
	"textBold": `ViewFailedPayout-textBold-FIjro`,
	"textBolder": `ViewFailedPayout-textBolder-v3sN4`,
	"textNormal": `ViewFailedPayout-textNormal-v22ql`,
	"textDarkBlue": `ViewFailedPayout-textDarkBlue-nt0cy`,
	"textLightBlue": `ViewFailedPayout-textLightBlue-vxkXV`,
	"textLightSandleGreen": `ViewFailedPayout-textLightSandleGreen-Ck1RB`,
	"textLightBrown": `ViewFailedPayout-textLightBrown-APK3s`,
	"textMediumMaroon": `ViewFailedPayout-textMediumMaroon-TnkcA`,
	"textBrown": `ViewFailedPayout-textBrown-HVU0z`,
	"textMaroon": `ViewFailedPayout-textMaroon-dAHvl`,
	"textDarkBrown": `ViewFailedPayout-textDarkBrown-y7WI6`,
	"textMediumBrown": `ViewFailedPayout-textMediumBrown-owHin`,
	"textSkyBlue": `ViewFailedPayout-textSkyBlue-fHpKM`,
	"textGray": `ViewFailedPayout-textGray-xBR3G`,
	"errorMessage": `ViewFailedPayout-errorMessage-lLW28`,
	"userText": `ViewFailedPayout-userText-oIimf`,
	"panelHeader": `ViewFailedPayout-panelHeader-Jrn5Q`,
	"exportSection": `ViewFailedPayout-exportSection-r57Bx`,
	"exportSectionGridSub": `ViewFailedPayout-exportSectionGridSub-ge3qD`,
	"exportText": `ViewFailedPayout-exportText-_4nzV`,
	"exportLinkImg": `ViewFailedPayout-exportLinkImg-fMRAi`,
	"exportImg": `ViewFailedPayout-exportImg-Zhhmu`,
	"linkBtn": `ViewFailedPayout-linkBtn-r4sHw`,
	"table": `ViewFailedPayout-table-Lu5BP`,
	"tableRow": `ViewFailedPayout-tableRow-fQrbt`,
	"tableCell": `ViewFailedPayout-tableCell-MDH7r`,
	"formGroup": `ViewFailedPayout-formGroup-J0lIQ`,
	"marginTop0": `ViewFailedPayout-marginTop0-ZRFpP`,
	"marginBottom20": `ViewFailedPayout-marginBottom20-ASlG0`,
	"bannerImageBg": `ViewFailedPayout-bannerImageBg-qfFxO`,
	"bannerDelete": `ViewFailedPayout-bannerDelete-uSg4s`,
	"exportLink": `ViewFailedPayout-exportLink-M5Bio`,
	"seachContent": `ViewFailedPayout-seachContent-uYL3m`,
	"marginBottom9": `ViewFailedPayout-marginBottom9-K5Dek`,
	"spaceTop52": `ViewFailedPayout-spaceTop52-yUQjn`,
	"profileViewInner": `ViewFailedPayout-profileViewInner-HUOU5`,
	"profileViewMain": `ViewFailedPayout-profileViewMain-zpogq`,
	"profileViewlabel": `ViewFailedPayout-profileViewlabel-bEahm`,
	"profileViewMainContent": `ViewFailedPayout-profileViewMainContent-bM4sh`,
	"reviewsFormStar": `ViewFailedPayout-reviewsFormStar-RPEny`,
	"addLanguageText": `ViewFailedPayout-addLanguageText-HN2mA`
};
module.exports = ___CSS_LOADER_EXPORT___;
